export default {
  path: 'dashboard',
  name: 'dashboard',
  component: () => import('pages/dashboard/IndexPage.vue'),
}
